import { createAsyncThunk } from '@reduxjs/toolkit';
import { DateTime } from 'luxon';
import { ScanLogAggregations } from 'src/types/scanLogTypes';

export const fetchAggregatedESScans = createAsyncThunk<
	ScanLogAggregations,
	FetchAggregatedESScansPayload,
	{ rejectValue: string }
>(
	'scanlogs/fetchAggregatedESScans',
	async (
		{ api, id, startDate, endDate, searchText, searchField, filters },
		{ rejectWithValue },
	) => {
		const formattedStartDate = startDate
			? DateTime.fromISO(startDate)
					.toUTC()
					.toFormat('yyyy-MM-dd HH:mm:ss')
			: null;

		const formattedEndDate = endDate
			? DateTime.fromISO(endDate).toUTC().toFormat('yyyy-MM-dd HH:mm:ss')
			: null;

		try {
			return await api.getAccountAggregateESScans(
				id,
				formattedStartDate,
				formattedEndDate,
				searchText,
				searchField,
				filters,
			);
		} catch (error) {
			const message =
				error instanceof Error
					? error.message
					: 'An unexpected error occurred';
			return rejectWithValue(message);
		}
	},
);

type FetchAggregatedESScansPayload = {
	api: {
		getAccountAggregateESScans: (
			id: string,
			startDate: string,
			endDate: string,
			searchText: string,
			searchField: string,
			filters: string[],
		) => Promise<ScanLogAggregations>;
	};
	id: string;
	startDate: string;
	endDate: string | null;
	searchText: string;
	searchField: string;
	filters: string[];
};
